<template>
    <v-progress-linear :value="progressPercent" :color="progressColor"></v-progress-linear>
</template>

<script>
    export default {
        name: 'CategoryStatus',
        props: {
          category: Object
        },
        computed: {
            participants () {
                return this.$store.state.participants
            },
            progressPercent () {
                let participants = this.participants.filter(participant => participant.category === this.category.id && participant.startNumber > 0)
                let max = participants.length * this.category.checkpoints.length
                if (max === 0) return 0
                let ready = 0
                participants.forEach(participant => {
                    ready += participant.progress
                })
                return (ready / max * 100).toFixed(0)
            },
            progressColor () {
                const percent = this.progressPercent
                if (parseInt(percent) > 0) {
                    return 'success'
                }

                return 'error'
            }
        }
    }
</script>
